import type { UUIDFile, UUIDPromise } from "@overmap-ai/forms"
import React, { memo } from "react"

import { CommentFileThumbnailListItem } from "./CommentFileThumbnailListItem"

interface CommentFileThumbnailListProps {
	files: (UUIDFile | UUIDPromise<UUIDFile>)[]
	onDelete: (file: UUIDFile | UUIDPromise<UUIDFile>) => void
}

export const CommentFileThumbnailList = memo((props: CommentFileThumbnailListProps) => {
	const { files, onDelete } = props

	return (
		<div className="flex w-full flex-wrap gap-2">
			{files.map((file) => {
				return <CommentFileThumbnailListItem key={file.uuid} file={file} onDelete={onDelete} />
			})}
		</div>
	)
})
CommentFileThumbnailList.displayName = "CommentFileThumbnailList"
